<!--
Screen to display library items.

@author ab557z
-->
<template>
  <div id="contain" class="container">
    <Nav name="Library" :step="true" />
    <div id="discovery-search-box">
        <div id="searchContainer">
            <label for="discovery-search" id="searchLabel">Search University of Glasgow Library</label>
              <div id="searchElements">
                    <p 
                      v-if="formError" 
                      class="error-message" 
                      id="searchError"
                      role="alert"
                      >Please enter a search term. </p>
                    <input 
                      type="text" 
                      id="discovery-search" 
                      ref="searchInput"
                      v-model="searchQuery" 
                      @keyup.enter="submitSearch" 
                      :class="{ 'error-border': formError }"
                      :aria-describedby="formError ? 'searchError' : undefined"
                      :aria-invalid="formError"
                      >
                    <button class="btn" @click="submitSearch">Search</button>
              </div>
          </div>
    </div>
    <div id="libraryLinksContainer">
      <div class="library-link">
        <a href="https://gla.on.worldcat.org/signin" target="_blank">Library login</a>
        <font-awesome-icon icon="external-link" size="lg"></font-awesome-icon>
      </div>
      <div class="library-link padding-border">
        <a href="https://gla.account.worldcat.org/account/checkouts" target="_blank">Library checkouts</a>
        <font-awesome-icon icon="external-link" size="lg"></font-awesome-icon>
      </div>
    </div>
    <div id="pusher" />
    <Footer active="library" />
  </div>
</template>

<script setup>
  import { ref, nextTick } from 'vue'
  import Footer from '@/components/FooterMenu.vue'

  const searchQuery = ref('')
  const formError = ref(false)
  const searchInput = ref(null);

  async function submitSearch() {
    const trimmedQuery = searchQuery.value.trim(); //remove whitespace
    //If search input is not blank, open the URL with the query inserted in a new tab
    if (trimmedQuery !== '') {
      formError.value = false
      const url = `https://gla.on.worldcat.org/external-search?queryString=${encodeURIComponent(trimmedQuery)}&clusterResults=on&groupVariantRecords=off&stickyFacetsChecked=on`
      window.open(url, '_blank');
    }
    else { //If search input is blank, show error messages and return focus to input box
      formError.value = true
      await nextTick();
      searchInput.value.focus();
    }
  }

</script>
<style lang="scss" scoped>

/** Search box **/
#discovery-search-box {
  margin-top:2rem;
  padding: 0px 1rem;
}

#searchElements {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

#discovery-search {
  height: 45px;
  flex-grow: 1;
  margin-right: 8px;
  padding: 0px 0.5em;
  font-size: 1.2rem;
  border: solid 1px #767676;
}

#searchLabel {
  color: var(--uog-dark-blue);
  font-size: 1.3rem
}

@media (max-width: 500px) {
    #searchElements {
        flex-wrap: wrap;
        justify-content: flex-end;
    }

    #discovery-search {
        flex-basis: 100%;
        margin-bottom: 8px;
        margin-right: 0px;
    }
}

/** Button **/
#searchContainer .btn {
    font-size:20px;
    background-color: var(--uog-dark-blue);
    border: solid 1px var(--uog-dark-blue);
    padding: 9px 16px;
    color:#fff;
    margin:4px 0px;
    line-height:normal;
    transition: background-color 0.4s, color 0.4s, border-color 0.4s;
}

#searchContainer .btn:hover {
    background-color:#fff;
    border: solid 1px var(--uog-dark-blue);
    color: var(--uog-dark-blue);
}

#searchContainer .btn:focus-visible {
    outline: 3px solid #000;
}

#searchContainer .btn:active {
    background-color: var(--uog-dark-blue);
    color: #fff;
}

/** form error */
#searchError {
  flex-basis: 100%;
  margin-bottom: 0px;
}

.error,
.error-message {
    color: var(--uog-error-red);
}

#discovery-search.error-border {
    border:solid 1px var(--uog-error-red);
}

/** Library login link **/
#libraryLinksContainer {
  margin-top: 1.5rem;
  padding-left: 1rem;
  display: flex;
}

#libraryLinksContainer a {
  color: var(--uog-dark-blue);
  text-decoration: none;
  font-size: 18px;
}

#libraryLinksContainer a:hover {
  text-decoration: underline;
}

.library-link {
  margin-right: 1rem;
}

.padding-border {
  padding-left: 1rem;
  border-left: solid 1px #ccc;
}

.library-link svg {
  color: var(--uog-dark-blue);
  font-size: 16px;
  margin-left: 5px;
}
</style>
